import React, { useEffect, useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { SmartphoneIcon } from 'lucide-react';
export function FloatingCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const windowHeight = window.innerHeight;
      const docHeight = document.documentElement.scrollHeight;
      const footerHeight = 80;
      const atBottom = scrollY + windowHeight >= docHeight - footerHeight;
      setVisible(scrollY > 400 && !atBottom);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-15">
      {visible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      duration: 0.3
    }} className="fixed bottom-0 left-0 right-0 z-50 p-3 md:p-4" style={{
      backgroundColor: 'rgba(44, 24, 16, 0.95)'
    }} data-id="element-16">
          <div className="max-w-3xl mx-auto flex justify-center" data-id="element-17">
            <motion.a href="https://wa.me/584221732264?text=Hola!%20Vengo%20de%20la%20página%20de%20Repostería%20de%20Guerra.%20Quiero%20el%20Kit%20de%20$3.50%20y%20pagar%20por%20Pago%20Móvil.%20¿Me%20das%20los%20datos?" target="_blank" rel="noopener noreferrer" whileHover={{
          scale: 1.03
        }} whileTap={{
          scale: 0.97
        }} className="inline-flex items-center justify-center gap-3 bg-[#25D366] hover:bg-[#20BA5A] text-white font-bold text-lg md:text-xl py-4 px-8 md:py-5 md:px-12 rounded-full shadow-warm-lg transition-colors w-full md:w-auto" data-id="element-18">
              <SmartphoneIcon className="w-6 h-6" data-id="element-19" />
              <span data-id="element-20">PAGAR POR PAGO MÓVIL (WhatsApp)</span>
            </motion.a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}